// 상담 채팅(고객 쪽) — sv-support 실 엔드포인트 호출. StudioChatbotPage(실사용)·TestSupportChatPage(테스트) 공용.
// 인증: C-05 §3.5 표준대로 FE는 신원 헤더를 절대 직접 보내지 않는다 — FlowGate가 JWT에서 검증해
// X-User-Id를 자동으로 넣어주고, sv-support가 그걸 그대로 memberId로 사용한다(apiClient가 이미
// Authorization: Bearer를 붙이므로 이 파일은 신원 관련 헤더를 아무것도 설정하지 않는다).
import { apiClient, API_PRX } from '@indipia/shared';

const BASE = API_PRX.SUPPORT;

export interface SupportMessageDto {
  messageId: number;
  senderType: 'CUSTOMER' | 'AGENT' | 'SYSTEM';
  senderId: number | null;
  messageContent: string;
  createdAt: string;
}

export interface SupportMessageListDto {
  items: SupportMessageDto[];
  nextCursor: number | null;
  hasNext: boolean;
}

export interface SupportCaseCreateDto {
  caseId: number;
  caseStatus: 'WAITING' | 'ASSIGNED' | 'IN_PROGRESS' | 'DONE';
  caseChannel: 'CHATBOT' | 'INQUIRY';
}

interface ApiResponse<T> {
  data: T;
}

export function listSupportMessages(caseId: string, cursor?: number) {
  return apiClient.get<ApiResponse<SupportMessageListDto>>(`${BASE}/cases/${caseId}/messages`, {
    params: { cursor, limit: 50 },
  });
}

/** 핸드오프 시뮬레이션 — 실제로는 챗봇 쪽이 호출할 case 생성 API를 이 화면이 대신 호출한다. */
export function createSupportCase(memberId: number, memberName: string, initialMessage: string) {
  return apiClient.post<ApiResponse<SupportCaseCreateDto>>(`${BASE}/cases`, {
    caseChannel: 'CHATBOT',
    inquirerType: 'MEMBER',
    memberId,
    memberName,
    botContext: JSON.stringify({ initialMessage }),
  });
}

/** 이어보기 — 이 회원의 진행중 CHATBOT case 조회. 없으면 data:null. */
export function getMyActiveCase() {
  return apiClient.get<ApiResponse<SupportCaseCreateDto | null>>(`${BASE}/cases/me/active`);
}

interface StatusUpdateDto {
  caseId: number;
  caseStatus: SupportCaseCreateDto['caseStatus'];
}

/** 고객이 능동적으로 상담 종료 — 담당자 배정 여부와 무관하게 이 case의 본인이면 언제든 종료 가능. */
export function closeSupportCase(caseId: string) {
  return apiClient.post<ApiResponse<StatusUpdateDto>>(`${BASE}/cases/${caseId}/close-by-customer`);
}

/** 읽음 처리(비대칭 읽음, FR-13) — 여기까지 봤다는 커서를 갱신하면 상담사 화면에 READ_RECEIPT로 실시간 반영된다. */
export function markSupportRead(caseId: string, lastReadMessageId: number) {
  return apiClient.patch<ApiResponse<void>>(`${BASE}/cases/${caseId}/read`, { lastReadMessageId });
}
